import React, { useEffect, useState } from 'react';
import ListView from './ListView.js';
import DetailView from './DetailView.js';
import axios from 'axios';

export default function AppWrapper() {
  const [fetchedUTMList, updateUTMList] = useState([]); // UTM batch fetched from db
  const [curBatch, setBatch] = useState({}); // Once a batch is selected for editing changes view
  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(true);

  const isEmpty = (obj) => Object.keys(obj).length === 0;

  const curView = isEmpty(curBatch) ? (
    <ListView setBatch={setBatch} batchList={fetchedUTMList} curUser={user} />
  ) : (
    <DetailView changeView={setBatch} curBatch={curBatch} />
  );

  // Sorts UTM Batch by Timestamp
  const sortByRecent = (utmData) => {
    const options = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    };
    let utmArray = [utmData];

    utmArray = utmArray.map((i) => {
      const values = Object.values(i);
      values.sort((a, b) => a.date - b.date);
      values.reverse();

      // Format Date for List View
      values.forEach((i) => {
        let newDate = new Date();
        newDate.setTime(i.date * 1000);
        const dateString = newDate.toLocaleDateString(undefined, options);
        const timeString = newDate.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          timeZone: 'UTC'
        });
        const formattedTime = dateString + ' ' + timeString;
        i.date = formattedTime;
      });
      return values;
    });

    return utmArray;
  };

  useEffect(() => {
    const fetchData = async () => {
      await axios
        .get('/wp-admin/admin-ajax.php?action=get_utm_codes_for_user')
        .then((res) => {
          setUser(res.data.data.userID);
          let utmData = [];
          utmData[0] = res.data.data.utms;
          utmData = sortByRecent(utmData[0]);
          updateUTMList(utmData);
          setLoading(false);
        });
    };
    fetchData();
  }, [curBatch]);

  return (
    <div>
      <div className="utm utm__app-wrapper">
        {loading ? (
          <div className="container u--margin-top-35">
            <div>Loading...</div>
          </div>
        ) : (
          <div>{curView}</div>
        )}
      </div>
    </div>
  );
}
